export default "__VITE_PUBLIC_ASSET__ae2c34c5__"